// extracted by mini-css-extract-plugin
export default {"add-company-access-button":"AddCompanyAccessButton_add-company-access-button__IpNmN"};